<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>접수 확인 및 취소</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>접수 확인 및 취소</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="inform_box mb60">
            <ol class="nb_dot li_space">
              <li>
                <span class="ol_li_txt medium">교육비 입금</span><br />
                <ol class="dot">
                  <li class="grey">
                    <span class="ol_li_txt">
                      계&nbsp;&nbsp;&nbsp;&nbsp;좌:
                      <span class="color bold"
                        >농협 355-0066-4272-33 ｜ (사)한국외식산업협회</span
                      >
                    </span>
                  </li>
                  <li class="grey">
                    <span class="ol_li_txt">
                      응시료:
                      <span class="color bold">50,000원(교재비 미포함)</span>
                    </span>
                  </li>
                </ol>
                <span class="color small"
                  >※ 접수기간 중 접수마감일까지 교육비를 입금하지 않으면
                  교육신청이 자동취소됩니다.</span
                >
              </li>
              <li>
                <span class="ol_li_txt medium">환불</span><br />
                <ol class="dot">
                  <li class="grey">
                    <span class="ol_li_txt"
                      >교육신청 마감 전까지 100% 환불</span
                    >
                  </li>
                  <li class="grey">
                    <span class="ol_li_txt">교육신청 마감 후 환불 불가</span>
                  </li>
                </ol>
                <span class="color small"
                  >※ 취소 후 환불되기까지 약 2~7일 정도 소요됩니다.</span
                >
              </li>
            </ol>
          </div>
          <div class="table">
            <div class="row head">
              <div class="cell fix150"><p>번호</p></div>
              <div class="cell"><p>제목</p></div>
              <div class="cell fix150"><p>등록일</p></div>
              <div class="cell fix180"><p>상태</p></div>
            </div>
            <div class="page_con" v-if="$Util.isEmpty(items)">
              <div class="empty_wrap">
                <div class="empty">
                  <span>내역이 존재하지 않습니다.</span>
                </div>
              </div>
            </div>
            <div class="row" v-for="(item, index) in items" :key="index">
              <div class="cell fix150">
                <p>{{ pageInfo.virtualNum - index }}</p>
              </div>
              <div class="cell">
                <p class="left">
                  {{ item.exam.titleName }}
                </p>
              </div>
              <div class="cell fix150">
                <p>{{ $moment(item.userExam.regDate).format('YYYY.MM.DD') }}</p>
              </div>
              <div class="cell fix180">
                <div
                  class="btn_wrap"
                  v-if="
                    item.userExam.examStatus === 1 ||
                      item.userExam.examStatus === 2
                  "
                >
                  <p class="state color">
                    {{
                      item.userExam.examStatus === 1 ? '접수 완료' : '입금 확인'
                    }}
                  </p>
                  <button class="btn bo grey" @click="fnView(item)">
                    접수 확인 및 취소
                  </button>
<!--                  <button class="btn bo" @click="fnModal(item)">수강증 보기</button>-->
                </div>
                <p
                  class="state error"
                  v-else-if="item.userExam.examStatus === 3"
                >
                  취소
                </p>
              </div>
            </div>
          </div>
          <pagination
            v-bind="pageInfo"
            v-model="pageInfo.page"
            @change="fetchData"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-register-index',
  description: '접수 확인 및 취소',
  data: function() {
    return {
      params: {
        page: 1,
        limit: 10,
        examStatuses: ''
      },
      pageInfo: {},
      items: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData: async function(page = 1) {
      this.params.page = page
      const res = await this.$ManagerSvc.getListBoxUserExam(this.params)
      if (res.code === 1) {
        this.items = res.entity.list
        this.pageInfo = res.entity.pageInfo
      }
    },
    fnView: function(item) {
      this.$router.push({
        path: '/manager/exam/register/view',
        query: { userExaminationNo: item.userExam.userExaminationNo }
      })
    }
    // fnModal: function(item) {
    //   this.$store.commit('layout/setModalAlert', {
    //     modalAlertName: this.$modalAlertNames.MODAL_EDU_APPLICATION_POPUP,
    //     data: { item: item, applyType: 2 },
    //     callBack: () => {}
    //   })
    // }
  }
}
</script>

<style scoped></style>
